<template>
  <v-container fluid tag="section">
    <v-card id="conciliacao-tipos-concilicao" class="mx-auto v-card--wizard" elevation="12" max-width="700">
      <v-card-title class="display-2 font-weight-light justify-center pt-5" style="word-break: break-word">
        Selecione o tipo da sua conciliação
      </v-card-title>
      <v-card-text class="my-6">
        <general-card-item-group
          v-model="tipoConciliacao"
          :optionalId="true"
          :options="cardItemOptions"
          justify="center"
          @input="redirect($event)"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    components: {
      GeneralCardItemGroup: () => import('@/components/general/GeneralCardItemGroup')
    },

    data: () => ({
      tipoConciliacao: '',
      cardItemOptions: [
        {
          value: 'EXPRESS',
          text: 'Express',
          description: 'Conciliação simplificada e de rápida configuração.',
          icon: 'mdi-play-circle-outline'
        },
        {
          value: 'CUSTOM',
          text: 'Custom',
          description: 'Conciliação avançada e com mais configurações.',
          icon: 'mdi-target'
        }
      ]
    }),

    methods: {
      redirect(param) {
        if (param) {
          const rota = 'edit/' + param.toLowerCase();
          this.$router.push({ path: rota, params: { teste: 'asd' } });
        }
      }
    }
  };
</script>
